const imageDimensions: Record<string, { width: number; height: number }> = {
  'DiamondSuitesOcalaLogo.gif': { width: 1020, height: 200 },
  'DiamondSuitesDowntownOcalaLogo.gif': { width: 1500, height: 250 },
  'DiamondSuitesCrystalRiverLogo.gif': { width: 1020, height: 200 },
  'Home-banner-slider.webp': { width: 1440, height: 575 },
  'directory-banner.webp': { width: 1440, height: 721 },
  'home-banner-slider-01-1.webp': { width: 1920, height: 664 },
  'community-main.jpg': { width: 1081, height: 558 },
  'suite-interior.jpg': { width: 900, height: 1200 },
  'news-banner-img.webp': { width: 1440, height: 576 },
  'amenity-chair.webp': { width: 95, height: 133 },
  'amenity-space.webp': { width: 134, height: 133 },
  'amenity-secure.webp': { width: 104, height: 133 },
  'rosa-borrell.webp': { width: 299, height: 417 },
  'aubrey-novy.webp': { width: 360, height: 499 },
  'candice-fearon.webp': { width: 359, height: 501 }
}

export function imageSize(name: string) {
  return imageDimensions[name]
}
